export default {
  title: "{{name}}漫画",
  description: "{{name}}漫画精选 — 哔咔动漫免费下拉式在线阅读，海量{{name}}资源全免费",
  filterAll: "全部",
  filterHot: "热门",
  filterNew: "最新",
  filterFinished: "完结",
  empty: "暂无该分类下的漫画",
  backToHome: "返回首页",
};